import {Component, OnInit, Renderer2} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {QuestionnaireService} from '../../../../services/questionnaire.service';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {MatOptionSelectionChange} from '@angular/material/core';
import {ErrorDialogComponent} from '../../../user-actions/error-dialog/error-dialog.component';
import {IPAQSFResults, Q_IPAQ_SF} from '../../../../model/questionnaires/questionnaire-ipaq-sf';

@Component({
  selector: 'app-questionnaire-ipaq-sf',
  templateUrl: './questionnaire-ipaq-sf.component.html',
  styleUrls: ['./questionnaire-ipaq-sf.component.css']
})
export class QuestionnaireIpaqSfComponent implements OnInit {

  qForm: FormGroup;
  dataSource = Q_IPAQ_SF;
  notFocused = false;
  submitted = false;
  show = false;
  results = [];
  q = 'question';
  currentCheckedValue = [null];
  found = false;

  /// toolbar
  back = true;
  destination = '/questionnaires';
  title = 'IPAQ-SF';
  user = null;
  uuid = null;
  authorization: boolean;
  doctorID: string;
  patientSSN: string;
  box1bDisabled = true;
  box2bDisabled = true;
  box3bDisabled = true;


  constructor(private questionnaireService: QuestionnaireService,
              public dialog: MatDialog,
              private ren: Renderer2,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit(): void {
    this.qForm = new FormGroup({
      question1: new FormControl({value: ''}, [/*Validators.required,*/ Validators.min(0), Validators.max(7)]),
      question2: new FormControl({value: ''}, [/*Validators.required,*/ Validators.min(0)]),
      question3: new FormControl({value: ''}, [/*Validators.required,*/ Validators.min(0), Validators.max(7)]),
      question4: new FormControl({value: ''}, [/*Validators.required,*/ Validators.min(0)]),
      question5: new FormControl({value: ''}, [/*Validators.required,*/ Validators.min(0), Validators.max(7)]),
      question6: new FormControl({value: ''}, [/*Validators.required, Validators.min(0), Validators.max(7)*/]),
      question8: new FormControl({value: ''}, [Validators.required, Validators.min(0)]),
      question9: new FormControl({value: ''}, [Validators.required, Validators.min(0)]),
    });
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.dataSource.length; ++i) {
      this.results.push(null);
    }

    this.user = JSON.parse(localStorage.getItem('user'));
    this.route.params.subscribe(params => {
      this.doctorID = params.doctorID;
      this.patientSSN = params.patientSSN;
      this.uuid = params.uuid;
      this.authorization = this.user.ssn.localeCompare(params.patientSSN) === 0;
      if (params.back.localeCompare('questionnaires') === 0) {
        this.destination = 'questionnaires';
      } else if (params.back.localeCompare('choose-questionnaire') === 0) {
        this.destination = 'choose-questionnaire';
      }
    });
  }

  checkState(el, position: number) {
    setTimeout(() => {
      if (this.currentCheckedValue[position - 1] && this.currentCheckedValue[position - 1] === el.value) {
        el.checked = false;
        this.ren.removeClass(el._elementRef.nativeElement, 'cdk-focused');
        this.ren.removeClass(el._elementRef.nativeElement, 'cdk-program-focused');
        this.currentCheckedValue[position - 1] = null;
        this.results[position - 1] = null;
      } else {
        this.currentCheckedValue[position - 1] = el.value;
      }
    });
  }

  setAnswer(answer: string, position: number) {
    this.results[position - 1] = answer;
    //console.log(this.results);
  }

  setResult(position: number) {
    const question = 'question' + position;

    // tslint:disable-next-line:max-line-length
    if (this.qForm.get(question).value !== null && this.qForm.get(question).value >= 0) {
      this.results[position - 1] = this.qForm.get(question).value.toString();
    } else {
      this.results[position - 1] = null;
    }

    if(position === 1 && this.results[position - 1] > 0){
      this.box1bDisabled = false
    }
    if(position === 3 && this.results[position - 1] > 0){
      this.box2bDisabled = false
    }
    if(position === 5 && this.results[position - 1] > 0){
      this.box3bDisabled = false
    }
    console.log(this.results);
  }

  onSubmit() {
    this.submitted = true;
    this.show = true;
    this.found = false;

    if (this.results.length !== this.dataSource.length) {
      this.show = false;
      this.submitted = false;
      this.found = true;
      const msg = 'Non hai finito di completare il questionario!';
      this.openErrorDialog(msg);
    } else {
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.results.length; i++) {
        if (i === 0 || i === 2 || i === 4) {
          if (this.results[i] === '0' || this.results[i] === null) {
            if (this.results[i + 1] !== null) {
              this.show = false;
              this.submitted = false;
              this.found = true;
              let j = 0;
              if (i === 0) {
                j = 1;
              } else if (i === 2) {
                j = 2;
              } else if (i === 4) {
                j = 3;
              }
              // const msg = 'Non hai completato correttamente il questionario!\n Controlla le domande 1a), 2a) e 3a)';
              const msg = 'Non hai completato correttamente il questionario!\n' +
                'Hai compilato il campo della domanda ' + j + 'b) nonostante nella domanda ' + j + 'a) tu abbia lasciato il campo vuoto o uguale a 0';
              this.openErrorDialog(msg);
              break;
            }
          } /* else {
            if (this.results[i] === null) {
              this.show = false;
              this.submitted = false;
              this.found = true;
              const msg = 'Non hai finito di completare il questionario!';
              this.openErrorDialog(msg);
              break;
            }
          } */
        } else if (i !== 1 && i !== 3 && i !== 5) {
          if (i === 6) {
            if (this.results[i] === null && (this.results[i - 1] !== null || this.results[i - 2] !== null)){
              this.show = false;
              this.submitted = false;
              this.found = true;
              const msg = 'Non hai finito di completare il questionario! Risposta 3c) incompleta';
              this.openErrorDialog(msg);
              break;
            }
          } else {
            if (this.results[i] === null) {
              this.show = false;
              this.submitted = false;
              this.found = true;
              const msg = 'Non hai finito di completare il questionario!';
              this.openErrorDialog(msg);
              break;
            }
          }
        }
      }
    }

    if (!this.found) {
      let diagnosis = '';
      let q1 = this.qForm.get('question1').value;
      if (q1 === null || q1.value === null || q1.value === '') {
        this.results[0] = 0;
        q1 = 0;
      }
      let q2 = this.qForm.get('question2').value;
      if (q2 === null || q2.value === null || q2.value === '') {
        this.results[1] = 0;
        q2 = 0;
      }
      // const intense = (this.qForm.get('question1').value * this.qForm.get('question2').value) * 8;
      const intense = (q1 * q2) * 8;
      console.log(q2);
      let q3 = this.qForm.get('question3').value;
      if (q3 === null || q3.value === null || q3.value === '') {
        this.results[2] = 0;
        q3 = 0;
      }
      let q4 = this.qForm.get('question4').value;
      if (q4 === null || q4.value === null || q4.value === '') {
        this.results[3] = 0;
        q4 = 0;
      }
      // const moderate = (this.qForm.get('question3').value * this.qForm.get('question4').value) * 4;
      const moderate = (q3 * q4) * 4;

      let q5 = this.qForm.get('question5').value;
      if (q5 === null || q5.value === null || q5.value === '') {
        this.results[4] = 0;
        q5 = 0;
      }
      let q6 = this.qForm.get('question6').value;
      if (q6 === null || q6.value === null || q6.value === '') {
        this.results[5] = 0;
        q6 = 0;
      }

      let gradeIntensity = 0;
      if (this.results[6] !== null && this.results[6].includes('INTENSO')) {
        gradeIntensity = 3.3;
      } else if (this.results[6] !== null && this.results[6].includes('MODERATO')) {
        gradeIntensity = 3;
      } else if (this.results[6] !== null && this.results[6].includes('LENTO')) {
        gradeIntensity = 2.5;
      }
      if (this.results[6] === null) {
        this.results[6] = '';
      }

      // const walk = (this.qForm.get('question5').value * this.qForm.get('question6').value) * gradeIntensity;
      const walk = (q5 * q6) * gradeIntensity;

      const total = intense + moderate + walk;
      console.log('total ' + total);

      console.log(intense, moderate, walk, total);
      if (total < 700) {
        diagnosis = 'SEI INATTIVO';
      } else if (total >= 700 && total <= 2519) {
        diagnosis = 'SEI SUFFICIENTEMENTE ATTIVO';
      } else {
        diagnosis = 'SEI ATTIVO O MOLTO ATTIVO';
      }
      console.log(total, diagnosis);
      const resultToSend = new IPAQSFResults(this.doctorID, this.patientSSN, this.results, diagnosis);
      this.questionnaireService.sendForm(resultToSend, 'ipaq-sf', this.uuid);
      }
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  goHome() {
    if (this.user === null) {
      this.router.navigateByUrl('/startup');
    } else {
      this.router.navigateByUrl('/landing');
    }
  }

  /*validateBox1b(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const p = control.value;
      console.log(control.value);
      if ((this.results[0] === undefined || this.results[0] === 0 || this.results[0] === null) &&
          (p !== undefined && p !== 0 && p !== null)) {
        return {minLengthError: 'Risposta 1b non concorde alla risposta 1a'};
      }else{
        console.log("false");
      }
      return null;
    };
  }*/
}
